module.exports = __webpack_public_path__ + "static/media/new-edit-icon.856d57e6.svg";